module.exports = __webpack_public_path__ + "img/issa-elite-trainer-certified.1144562b.svg";